import {
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip as ReChartsTooltip,
    Scatter,
    ResponsiveContainer,
    ScatterChart,
    Label
} from 'recharts';
import {LinearProgress, Paper,} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import {
    bbFindEntityWithinPortfolioOrSelf,
    BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbErrorSection,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor, isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import React, {useEffect} from "react";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Badge} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";
import {fetchRiskCycleReport} from "../../../actions";
import Toolbar from "@material-ui/core/Toolbar";
import FullScreenComponentDialog from "../modals/FullScreenComponentDialog";

// const testData = [
//     {
//         "likelihood": 2.3,
//         "impact": 3.4,
//     },
//     {
//         "likelihood": 1.2,
//         "impact": 4.1,
//     },
//     {
//         "likelihood": 3.2,
//         "impact": 5,
//     },
//     {
//         "likelihood": 1.0,
//         "impact": 3.2,
//     },
//     {
//         "likelihood": 2.3,
//         "impact": 4.3,
//     },
//     {
//         "likelihood": 4.3,
//         "impact": 3.2,
//     },
//     {
//         "likelihood": 3,
//         "impact": 3,
//     },
//     {
//         "likelihood": 1,
//         "impact": 1,
//     }
// ];

// function getIntroOfPage(label) {
//     if (label === 'Page A') {
//         return "'Page A is about men's clothing'";
//     }
//     if (label === 'Page B') {
//         return "'Page B is about men's clothing'";
//     }
// }

function CustomTooltip({ payload, label, active }) {
    // console.log("tip payload is", payload, "label is", label, "active is", active)
    if (active && payload) {

        const dataPoint = payload && payload[0] && payload[0].payload ? payload[0].payload : null;
        return (
            <Widget styleName={`p-1 px-2`}>

                <h2 className="label">{`${ dataPoint && dataPoint.definition && dataPoint.definition.name ? dataPoint.definition.name : "--"}`}</h2>
                {/*{parseFloat(payload[0].payload.score) === 1 &&*/}
                {/*<Badge color={bbTranslateBreachRiskScoreToColor(payload[0].payload.score)}><span style={{fontSize: "larger"}}>Most Dangerous Threat Detected</span></Badge>*/}
                {/*}*/}
                <h1 className="label">{`Danger Rating: ${dataPoint && dataPoint.score ? parseFloat(dataPoint.score).toFixed(1) : "--"}`}</h1>

                {/*<h4 className={"text-center"}>Risk Category:</h4>*/}
                <p>
                    Likelihood: <Badge>{dataPoint && dataPoint.likelihood_score ? parseFloat(dataPoint.likelihood_score).toFixed(1) : "--"} </Badge> Impact <Badge> {dataPoint && dataPoint.impact_score ? parseFloat(payload[0].payload.impact_score).toFixed(1) : "--"}</Badge>
                </p>


                    <Badge color={dataPoint && dataPoint.score ? bbTranslateBreachRiskScoreToColor(dataPoint.score): "inactive-gray"}><span style={{fontSize: "larger"}}>{dataPoint && dataPoint.score ? bbTranslateBreachRiskScoreToCategory(dataPoint.score) : "Unknown"} Risk</span></Badge>

                <hr/>

                <p>
                    <em>Applicable service(s): {`${dataPoint && dataPoint.definition && dataPoint.definition.service ? dataPoint.definition.service : "--"}`}</em>
                </p>
                <p className={'text-right'}>
                    <small>
                        <em>Threat ID: {`${dataPoint && dataPoint.id}`}</em>
                    </small>

                </p>

                {/*<p className="intro">{getIntroOfPage(label)}</p>*/}
                {/*<p className="desc">Anything you want can be displayed here.</p>*/}
            </Widget>
        );
    }

    return null;
}

// const bbTickFormatter = (input) => {
//     return bbFormattedDateString(input, 'micro');
// }

//looks for vectors with identical likelihoods, and spaces them horizontally so they can be moused over
const vectorDataSpacer = (data) => {
    if (data && Array.isArray(data)) {
        const pointsOrganizedByLikelihood = {};
        for (const point of data) {
            const impactHalfNotch = Math.round(point.impact_score*2)/2; //creates a notch to group impacts within the nearest half point
            if(!pointsOrganizedByLikelihood[point.likelihood_score]) {
                pointsOrganizedByLikelihood[point.likelihood_score] = {}
            }
            if(!pointsOrganizedByLikelihood[point.likelihood_score][impactHalfNotch]) {
                pointsOrganizedByLikelihood[point.likelihood_score][impactHalfNotch] = []
            }
            pointsOrganizedByLikelihood[point.likelihood_score][impactHalfNotch].push(point);
        }
        // console.log("organized vectors by likelihood score", pointsOrganizedByLikelihood);

        //now, go through each member and adjust likelihood slightly
        const keys = Object.keys(pointsOrganizedByLikelihood);
        for (const likelihoodCategory of keys) {
            const impactKeys = Object.keys(pointsOrganizedByLikelihood[likelihoodCategory]);
            for (const impactCategory of impactKeys) {
                let index = 0; //used to determine if left, right, or center and magnitude
                let magnitude = 0;
                const increment = 0.15;
                for (const vector of pointsOrganizedByLikelihood[likelihoodCategory][impactCategory]) {
                    pointsOrganizedByLikelihood[likelihoodCategory][impactCategory][index] = {
                        ...vector,
                        likelihood_plotting_value: index % 2 === 0 ? vector.likelihood_score + (magnitude) : vector.likelihood_score + (-1 * magnitude)
                    }

                    magnitude = index % 2 === 1 ? magnitude : magnitude + increment;
                    index = index + 1;
                    //don't go too high. only allow 0.4 amount of total spreading then take the poison of overlapping
                    //because as of aug 2021, if you go higher than that it could bleed into another likelihood category and spreading is no longer defensibly ambiguous
                    if(magnitude > 0.4) {
                        magnitude = 0;
                    }
                }
            }

        }
        // console.log("organized vectors now given display likelihoods", pointsOrganizedByLikelihood);

        const displayAdjustedVectorArray = []
        for(const likelihoodCategory of keys) {
            const impactKeys = Object.keys(pointsOrganizedByLikelihood[likelihoodCategory]);
            for (const impactCategory of impactKeys) {
                for (const vector of pointsOrganizedByLikelihood[likelihoodCategory][impactCategory]) {
                    displayAdjustedVectorArray.push(vector)
                }
            }
        }

        // console.log("reorganized vectors in to a flat array", displayAdjustedVectorArray);

        return displayAdjustedVectorArray;
    } else {
        return null
    }
}

const CustomizedDot = (props) => {
    const { cx, cy, stroke, payload, value, diameter = 15, className="threat_dot"} = props;
    // console.log("in CustomizedDot payload", payload, "value", value)
    const dot = <path d="m86 50c0 19.883-16.117 36-36 36s-36-16.117-36-36 16.117-36 36-36 36 16.117 36 36"/>
    const color = bbTranslateBreachRiskScoreToColor(payload.score, true)

        return (
            <svg className={className} x={cx - (diameter/2)} y={cy - (diameter/2)} width={diameter} height={diameter} fill={color} viewBox="0 0 100 100">
                {dot}
            </svg>
        );

};

const RenderLineChart = ({   cycleInView = null,
                             showVectorRiskScore = false,
                             portfolioView = false,
                            showFullScreenButton = true,
                            chartHeight = 220
                         }) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, loadingCycles, loadingCyclesError} = useSelector(({breachrisk}) => breachrisk);
    // const customer = customers ? customers[customerInView] : null;
    const {authUser} = useSelector(({auth}) => auth);

    const dispatch = useDispatch();

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;


    const isUserAllowedToSeeDataInThisTable = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", entityInView);

    // let historyData = myEntity ? myEntity.history : null;

    //cycle data for current report view (standard)
    const lastCycle = myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;
    const vectorChartData = lastCycle && lastCycle.vectors ? Object.keys(lastCycle.vectors).map((k) => lastCycle.vectors[k]) : [];
    const vectorsChartDataWithArtificialSpacing = vectorDataSpacer(vectorChartData);

    //cycle data if cycleInView is passed prop
    const pastReportView = cycleInView && lastCycle && cycleInView !== lastCycle.id;

    useEffect(()=>{
        if(pastReportView && !loadingCycles[cycleInView]){
            if (cycleInView && myEntity && myEntity.cycles && !myEntity.cycles[cycleInView]) {
                dispatch(fetchRiskCycleReport({
                    customerId: customerIdToUse,
                    cycleId: cycleInView
                }))
            }
        }
    }, [cycleInView])

    const cycleToUsePRV = pastReportView && myEntity && myEntity.cycles && myEntity.cycles[cycleInView] ? myEntity.cycles[cycleInView] : null;
    const vectorChartDataPRV = cycleToUsePRV && cycleToUsePRV.vectors ? Object.keys(cycleToUsePRV.vectors).map((k)=> cycleToUsePRV.vectors[k]) : [];
    const vectorsChartDataWithArtificialSpacingPRV = pastReportView && vectorDataSpacer(vectorChartDataPRV);


    // let newHistoryReferenceArea = null;

    //if history data is too small, add a point to the front
    // if (historyData && historyData.length < 2 && historyData[0]) {
    //     let copyThisPoint = historyData[0];
    //     // copyThisPoint.cycle_date = (bbDangerousStringToDate(historyData[0].cycle_date) - 31)
    //     historyData = [copyThisPoint].concat(historyData);
    //     historyData = [copyThisPoint].concat(historyData);
    //
    //     newHistoryReferenceArea = <ReferenceArea label = "Unknown Risk Level" x1={bbTickFormatter(copyThisPoint.cycle_date)} x2={bbTickFormatter(historyData[historyData.length - 1].cycle_date)} y1={0} y2={10} stroke="red" strokeOpacity={0.3} />
    // }

// console.log("What are values inside of this chart? cycleInView", cycleInView, "pastRevportsView", pastReportView, "portfolio view", portfolioView, "vectorsChartData", vectorsChartDataWithArtificialSpacing, "same but for PRV", vectorsChartDataWithArtificialSpacingPRV, "just vector Chart data without spacing", vectorChartData, "okay this full screen wants to be past reports! BuT WHY, what's last cycle", lastCycle)
    return <Paper style={{marginBottom: "30px", padding: 3}} id={"riskScatterPlotOverview"}>

        <Toolbar className="table-header">
            <div className="title">
                <h2 variant="title" className={"arrayTableTitle bb-font-fridge-bold"}>
                    Risk Chart: Notable Threats <Tooltip title={`Attackers have ${isUserAllowedToSeeDataInThisTable ? vectorChartData.length : "Unk"} distinct types of pathways to cause a breach. This chart displays only one item for each type, but there could be multiple pathways for each item shown. ${isUserAllowedToSeeDataInThisTable ? "" : "Request access to this BreachRisk™ Report to see this data."}`}><span><Badge id={"num_threat_dots"}>{isUserAllowedToSeeDataInThisTable ? vectorChartData.length : "Unk"}</Badge></span></Tooltip>
                    {/*<Tooltip disableFocusListener*/}
                    {/*         title={"Each instance where an attacker has both the opportunity and capability to cause a breach."}>*/}
                    {/*    <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}*/}
                    {/*                   className={`text-muted`}/>*/}
                    {/*</Tooltip>*/}
                </h2>

            </div>

            {showFullScreenButton &&
                <div style={{marginLeft: 'auto'}} className={"px-2"}>
                    {fullScreenPopper}
                </div>
            }
        </Toolbar>
        <div className="row">
            <div className={"col-12"}>
                <p className={"text-center"}>These are some of the threats directly influencing your BreachRisk™ Score. To improve your score, address the most dangerous threats first.</p>
            </div>
        </div>
        {/*<Toolbar className="table-header">*/}
        {/*    <div className="title">*/}
        {/*        <h1 className={"text-center"}>Risk Chart: Threats <Tooltip title={`Attackers have ${isUserAllowedToSeeDataInThisTable ? vectorChartData.length : "Unk"} ways to cause a breach. ${isUserAllowedToSeeDataInThisTable ? "" : "Request access to this BreachRisk™ Report to see this data."}`}><span><Badge>{isUserAllowedToSeeDataInThisTable ? vectorChartData.length : "Unk"}</Badge></span></Tooltip></h1>*/}

        {/*    </div>*/}
        {/*    <p className={"text-center"}>These threats directly influence your BreachRisk™ Score. To improve your score, address the most dangerous threats first.</p>*/}

        {/*        <div style={{marginLeft: 'auto'}} className={"px-2"}>*/}
        {/*            {fullScreenPopper}*/}
        {/*        </div>*/}
        {/*</Toolbar>*/}
        <div className="row" style={{ height: chartHeight}}>


                <div className={"col-12"} id={"tourStepSummaryScatterChart"}>
                    <BBDisableChildren
                        isDisabled={isUserAllowedToSeeDataInThisTable}
                        brLevelRequired= {"infoLevel2"}
                        blurLevel={(isCurrentUserMemberOf(authUser, "admin")|| isCurrentUserMemberOf(authUser, "staff")) ? 0 : 5}
                        portfolioView={portfolioView}
                    >
                    {!portfolios || loadingPortfolios[customerIdToUse] ?
                        <Skeleton count={10}/>
                        : !myEntity || loadingPortfoliosError[customerIdToUse] ?
                            <div className={"text-center"}>
                                {bbErrorSection("80px")}
                            </div>
                            :
                                <ResponsiveContainer>
                                    {pastReportView
                                        ? <ScatterChart width={800} height={chartHeight}
                                                        data={vectorsChartDataWithArtificialSpacingPRV ? vectorsChartDataWithArtificialSpacingPRV : null}
                                                        margin={{top: 1, right: 10, left: 2, bottom: 0}}>
                                            <Scatter name="A school" data={vectorsChartDataWithArtificialSpacingPRV}
                                                     fill="#69A5FF" shape={<CustomizedDot diameter={chartHeight/14}/>}/>
                                            <CartesianGrid stroke="#ccc" strokeDasharray="3 3"/>
                                            {/*<ReChartsTooltip />*/}
                                            <ReChartsTooltip content={<CustomTooltip/>}/>
                                            <XAxis type={"number"} dataKey={"likelihood_plotting_value"}
                                                   name={"likelihood"} allowDecimals={false} domain={[0, 6]}
                                                   ticks={[2, 4]} tickFormatter={(a, b) => ""}>
                                                <Label value="Likelihood" offset={0} position="center"/>
                                            </XAxis>
                                            <YAxis label={{value: 'Impact', angle: -90, position: 'center'}}
                                                   type={"number"} dataKey={"impact_score"} name={"impact"}
                                                   domain={[0, 6]} ticks={[2, 4]} tickFormatter={(a, b) => ""}/>

                                        </ScatterChart>

                                        : <ScatterChart width={800} height={chartHeight}
                                                        data={vectorsChartDataWithArtificialSpacing ? vectorsChartDataWithArtificialSpacing : null}
                                                        margin={{top: 1, right: 10, left: 2, bottom: 0}}>
                                            <Scatter name="A school" data={vectorsChartDataWithArtificialSpacing}
                                                     fill="#69A5FF" shape={<CustomizedDot diameter={chartHeight/14}/>}/>
                                            <CartesianGrid stroke="#ccc" strokeDasharray="3 3"/>
                                            {/*<ReChartsTooltip />*/}
                                            <ReChartsTooltip content={<CustomTooltip/>} style={{position: "relative",}}/>
                                            <XAxis type={"number"} dataKey={"likelihood_plotting_value"}
                                                   name={"likelihood"} allowDecimals={false} domain={[0, 6]}
                                                   ticks={[2, 4]} tickFormatter={(a, b) => ""}>
                                                <Label value="Likelihood" offset={0} position="center"/>
                                            </XAxis>
                                            <YAxis label={{value: 'Impact', angle: -90, position: 'center'}}
                                                   type={"number"} dataKey={"impact_score"} name={"impact"}
                                                   domain={[0, 6]} ticks={[2, 4]} tickFormatter={(a, b) => ""}/>

                                        </ScatterChart>
                                    }
                                </ResponsiveContainer>
                    }
                    </BBDisableChildren>
                </div>


        </div>

    </Paper>
};

export default RenderLineChart;

const fullScreenPopper = <FullScreenComponentDialog componentToDisplay={<RenderLineChart showFullScreenButton={false} chartHeight={600}/>}/>